// index.js
import en from './en.json';
import ro from './ro.json';
import hu from './hu.json';
import bg from './bg.json';

export const defaultLocale = 'ro'

export const messages = {
  en: en,
  ro: ro,
  hu: hu,
  bg: bg
}